import { render, staticRenderFns } from "./TableEntity.vue?vue&type=template&id=ef88879e&scoped=true&"
import script from "./TableEntity.vue?vue&type=script&lang=js&"
export * from "./TableEntity.vue?vue&type=script&lang=js&"
import style0 from "./TableEntity.vue?vue&type=style&index=0&id=ef88879e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef88879e",
  null
  
)

export default component.exports